var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6931 11.6366C13.894 11.4357 14.2197 11.4357 14.4206 11.6366L14.4193 11.6359C14.6202 11.8368 14.6202 12.1625 14.4193 12.3634L12.3621 14.4206C12.262 14.5214 12.1303 14.5714 11.9987 14.5714C11.867 14.5714 11.7354 14.5207 11.6353 14.4206L9.57811 12.3634C9.3772 12.1625 9.3772 11.8368 9.57811 11.6359C9.77903 11.435 10.1047 11.435 10.3057 11.6359L11.4851 12.8153V6.51429C11.4851 6.2304 11.7155 6 11.9994 6C12.2833 6 12.5137 6.2304 12.5137 6.51429V12.816L13.6931 11.6366ZM7.88571 18.0001H16.1143C17.1545 18.0001 18 17.1546 18 16.1144V14.0573C18 13.7734 17.7696 13.543 17.4857 13.543C17.2018 13.543 16.9714 13.7734 16.9714 14.0573V16.1144C16.9714 16.5869 16.5867 16.9715 16.1143 16.9715H7.88571C7.41326 16.9715 7.02857 16.5869 7.02857 16.1144V14.0573C7.02857 13.7734 6.79817 13.543 6.51429 13.543C6.2304 13.543 6 13.7734 6 14.0573V16.1144C6 17.1546 6.84549 18.0001 7.88571 18.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.48e3115d08c48e551216dd1b3bf5df41.svg";
export { ForwardRef as ReactComponent };